import { isWeekend, format, isBefore, isAfter, isSameDay } from 'date-fns';
import { MONTH_NAMES, holidays } from '../constants/dates';
export const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    return format(date, 'MM/dd/yyyy');
};
export const formatDateDash = (timestamp) => {
    const date = new Date(timestamp);
    return format(date, 'MM-dd-yyyy');
};
/**
 * Return Date fns formatted date
 * @param timestamp
 */
export const formatDateFns = (timestamp) => {
    return format(new Date(timestamp), 'yyyy-MM-dd');
};
const getNumberOfDaysInMonth = (y, m) => {
    return new Date(y, m + 1, 0).getDate();
};
const getMonth = (day, _month) => {
    if (_month === 0) {
        return day.m;
    }
    if (_month < 0) {
        return day.m - 1;
    }
    return day.m + 1;
};
export const getDayDetails = (day) => {
    const date = day.index - day.firstDay;
    let prevMonth = day.m - 1;
    let prevYear = day.y;
    if (prevMonth < 0) {
        prevMonth = 11;
        prevYear -= 1;
    }
    let _month = 0;
    if (date < 0) {
        _month = -1;
    }
    else if (date >= day.numberOfDays) {
        _month = 1;
    }
    const prevMonthNumberOfDays = getNumberOfDaysInMonth(prevYear, prevMonth);
    const _date = (date < 0 ? prevMonthNumberOfDays + date : date % day.numberOfDays) + 1;
    const month = getMonth(day, _month);
    const timestamp = new Date(day.y, month, _date, 0, 0, 0, 0).getTime();
    return {
        date: _date,
        prevMonth: _month !== 0,
        isWeekend: isWeekend(new Date(timestamp)),
        _month,
        timestamp,
        isHoliday: holidays.includes(formatDateFns(timestamp))
    };
};
export const getMonthDetails = (y, m) => {
    const result = [];
    const firstDay = new Date(y, m).getDay();
    const numberOfDays = getNumberOfDaysInMonth(y, m);
    const rows = 6;
    const cols = 7;
    let index = 0;
    for (let row = 0; row < rows; row++) {
        for (let col = 0; col < cols; col++) {
            result.push(getDayDetails({
                index,
                numberOfDays,
                firstDay,
                y,
                m
            }));
            index += 1;
        }
    }
    return result;
};
export const generateDaysOfMonth = () => {
    const options = [];
    for (let i = 1; i <= 31; i++) {
        let postfix = 'th';
        if ([1, 21, 31].includes(i)) {
            postfix = 'st';
        }
        else if ([2, 22].includes(i)) {
            postfix = 'nd';
        }
        else if ([3, 23].includes(i)) {
            postfix = 'rd';
        }
        options.push({ label: i + postfix, value: i });
    }
    options.push({ label: 'Last day', value: -1 });
    return [...options];
};
export const generateYears = (year, shift, length = 20) => {
    const years = [];
    const startYear = year - (year % length) + shift * length;
    for (let i = 0; i < length; i++) {
        years.push(startYear + i);
    }
    return years;
};
export const isTodayDay = (timestamp) => {
    return timestamp === new Date().setHours(0, 0, 0, 0);
};
export const getMonthStr = (month) => MONTH_NAMES[month];
export const getDay = (day) => {
    return new Date(day.timestamp);
};
/**
 * Is before specific date
 * @param day
 * @param minDate
 */
export const isBeforeMinDate = ({ day, minDate }) => {
    return minDate && isBefore(getDay(day), new Date(minDate));
};
/**
 * Is after specific date
 * @param day
 * @param maxDate
 */
export const isAfterMaxDate = ({ day, maxDate }) => {
    return maxDate && isAfter(getDay(day), new Date(maxDate));
};
/**
 * If day is holiday
 * @param day
 */
export const isHolidayOrWeekend = ({ day }) => {
    return day.isWeekend || day.isHoliday;
};
/**
 * If this day was selected
 * @param earlySelectedDates
 * @param day
 */
export const isEarlySelected = ({ earlySelectedDates, day }) => {
    return earlySelectedDates.some((date) => isSameDay(date, getDay(day)));
};
/**
 * If day is disabled
 * @param day
 * @param minDate
 * @param maxDate
 */
export const isDayNotClickable = (day, minDate, maxDate) => {
    return isBeforeMinDate({ day, minDate }) || isAfterMaxDate({ day, maxDate }) || isHolidayOrWeekend({ day });
};
